import { render, staticRenderFns } from "./ItemsSearchField.vue?vue&type=template&id=ddae2018&scoped=true&"
import script from "./ItemsSearchField.vue?vue&type=script&lang=js&"
export * from "./ItemsSearchField.vue?vue&type=script&lang=js&"
import style0 from "./ItemsSearchField.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ItemsSearchField.vue?vue&type=style&index=1&id=ddae2018&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddae2018",
  null
  
)

export default component.exports
import {QSelect,QChip,QList,QItem,QItemSection,QItemLabel,QSeparator,QIcon,QBtn,QDialog,QTd,QTooltip,QMenu,QField} from 'quasar'
component.options.components = Object.assign({QSelect,QChip,QList,QItem,QItemSection,QItemLabel,QSeparator,QIcon,QBtn,QDialog,QTd,QTooltip,QMenu,QField}, component.options.components || {})
